import styled from "styled-components"

const SectionTitle = styled.h3`
  font-weight: 500;
  margin-bottom: 0.66em;
`
export default SectionTitle
